'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CamOverlay = require('../CamOverlay');

var _CamOverlay2 = _interopRequireDefault(_CamOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamUpsell = function CamUpsell(_ref) {
  var stillUrl = _ref.stillUrl,
      href = _ref.href,
      onClick = _ref.onClick,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cam-upsell' },
    _react2.default.createElement(_CamOverlay2.default, { backgroundImage: 'url(' + stillUrl + ')' }),
    _react2.default.createElement(
      'div',
      { className: 'quiver-cam-upsell__message' },
      _react2.default.createElement(
        'div',
        { className: 'quiver-cam-upsell__message__header' },
        text.primary
      ),
      _react2.default.createElement(
        'a',
        { href: href, onClick: onClick },
        _react2.default.createElement(
          'button',
          null,
          text.link
        )
      ),
      _react2.default.createElement('div', {
        className: 'quiver-cam-upsell__message__subtext',
        dangerouslySetInnerHTML: { __html: text.secondary }
      })
    )
  );
};

CamUpsell.propTypes = {
  stillUrl: _propTypes2.default.string.isRequired,
  href: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  text: _propTypes2.default.shape({
    primary: _propTypes2.default.string,
    link: _propTypes2.default.string,
    secondary: _propTypes2.default.string
  })
};

CamUpsell.defaultProps = {
  href: null,
  onClick: null,
  text: {
    primary: 'Watch waves, not ads. Start your free trial now.',
    link: 'GO PREMIUM',
    secondary: 'To watch for 30 more seconds, \n    <a href="#" onClick="window.location.reload(true)">refresh the camera</a>.'
  }
};

exports.default = CamUpsell;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamUpsell/CamUpsell.js
// module id = 547
// module chunks = 11